/**
 * Created by Mikhail Menshenin on 09.08.2024
 */

cleverapps.Lives.prototype.getMaxLives = function () {
    return 50;
};

cleverapps.Lives.prototype.canShowForce = function () {
    return false;
};
// the game has a single currency (coins are hard), so spins are bought with it
VirtualProducts.initialize = cleverapps.extendFunc(VirtualProducts.initialize, function () {
    this._super();

    [VirtualProducts.buyEnergy350, VirtualProducts.buyEnergy700, VirtualProducts.buyEnergy].forEach((product) => {
        product.type = Product.TYPE_HARD;
        product.currency = "hard";
    });
});
